/** Transient API failures that are worth auto-retrying (Cloud SQL slot / 5xx). */
export function isTransientQueryError(error: unknown): boolean {
  const msg = (error instanceof Error ? error.message : String(error ?? '')).toLowerCase()
  if (!msg) return false
  return (
    msg.includes('internal server') ||
    msg.includes('connection slot') ||
    msg.includes('remaining connection') ||
    msg.includes('econnreset') ||
    msg.includes('etimedout') ||
    msg.includes('timeout') ||
    msg.includes('502') ||
    msg.includes('503') ||
    msg.includes('504') ||
    msg.includes('429') ||
    /request failed \(5\d\d\)/.test(msg)
  )
}

/** React Query `retry` callback — up to 3 attempts on transient errors only. */
export function queryRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 3) return false
  return isTransientQueryError(error)
}

export function queryRetryDelay(attemptIndex: number): number {
  return Math.min(1000 * 2 ** attemptIndex, 8000)
}
